import type { ROLE } from 'services/assist-api/entities/role/roles';
import type { AuthorisableUser } from './types';

// Helper functions (don't use these directly for authorising actions; use a policy action):

/**
 * Returns true if and only if the user has at least one of the accepted roles.
 */
export function hasRole(user: AuthorisableUser, acceptedRoles: ROLE[]): boolean {
  return user.roles.some((role) => acceptedRoles.includes(role));
}
